export { PrizmDestroyService } from './destroy.service';
